// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root___sDhO","index":"styles_index__3Kb9P"};